import * as React from "react";

interface SuccessIconProps {
  size: number;
  // Define other props here
  [key: string]: any; // Allow any other props
}
const SuccessIcon = (props: SuccessIconProps) => (
  <svg
    width={props?.size || 98}
    height={props?.size || 98}
    viewBox="0 0 98 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.0144 7.99378C36.1353 3.25466 42.2166 0.25 49 0.25C55.7831 0.25 61.8641 3.25436 65.985 7.99307C72.2505 7.55532 78.6761 9.73079 83.4731 14.5279C88.2702 19.3249 90.4457 25.7504 90.008 32.016C94.7461 36.1368 97.75 42.2174 97.75 49C97.75 55.7838 94.745 61.8655 90.0053 65.9864C90.4421 72.2509 88.2666 78.6751 83.4703 83.4713C78.6741 88.2675 72.2499 90.4431 65.9854 90.0063C61.8646 94.7454 55.7833 97.75 49 97.75C42.217 97.75 36.136 94.7457 32.0152 90.0071C25.7496 90.4449 19.324 88.2694 14.5269 83.4723C9.72978 78.6752 7.55429 72.2496 7.99206 65.9841C3.25393 61.8632 0.25 55.7826 0.25 49C0.25 42.2171 3.25423 36.1361 7.99277 32.0153C7.5555 25.7502 9.73103 19.3254 14.5277 14.5287C19.3244 9.732 25.7493 7.55647 32.0144 7.99378ZM67.0515 39.9296C68.2553 38.2443 67.8649 35.9023 66.1796 34.6985C64.4943 33.4947 62.1523 33.8851 60.9485 35.5704L44.7715 58.2182L36.6516 50.0984C35.1872 48.6339 32.8128 48.6339 31.3484 50.0984C29.8839 51.5628 29.8839 53.9372 31.3484 55.4016L42.5984 66.6517C43.3778 67.4311 44.4607 67.8281 45.5593 67.7372C46.6579 67.6463 47.6608 67.0766 48.3015 66.1796L67.0515 39.9296Z"
      fill="#028E57"
    />
  </svg>
);
export default SuccessIcon;
